import type { WorkflowCompletion } from '@interfaces/workflow';
import { createContext } from 'react';

export type ActionContextInterface = {
  activeWorkflows: WorkflowCompletion[];
  /** True while the page's active-workflows query is in flight (empty list is not trustworthy). */
  activeWorkflowsLoading?: boolean;
  activeUserId?: string;
  unsignedDocuments: boolean;
  refetch: () => void;
  refreshWidgets?: () => void;
  widgetRefreshSignal?: number;
};

export const ActionContext = createContext<ActionContextInterface>({
  activeWorkflows: [],
  activeWorkflowsLoading: false,
  unsignedDocuments: false,
  refetch: () => {},
  refreshWidgets: () => {},
  widgetRefreshSignal: 0,
});
